<template>
  <v-card class="mx-auto" elevation="0">
    <v-card-title class="text-left card-header fixed-card-title2">{{ $t('add-license') }}
      <v-spacer></v-spacer>
      <v-icon class="white--text float-end mr-1" @click="closeDrawer">mdi-close</v-icon>
    </v-card-title>
    <div class="d-flex justify-center">
      <v-radio-group hide-details dense row  v-model="selectedLicence">
        <v-radio :value="0" :label="$t('single-licence')"></v-radio>
        <v-radio :value="1" :label="$t('bulk-licences')"></v-radio>
      </v-radio-group>
    </div>
    <v-row  class="mx-1 mt-1" dense>
      <v-col v-if="selectedLicence === 1" :cols="6">
        <v-text-field hide-details type="number" v-model="numberLicenses" :label="$t('number-licences')" outlined dense></v-text-field>
      </v-col>
      <v-col :cols="selectedLicence === 1 ? 6 : 12" >
        <v-text-field hide-details type="number" v-model="price" :label="$t('price')" outlined dense></v-text-field>
      </v-col>
    </v-row>
    <v-row class="ma-2" dense>
      <v-text-field hide-details dense v-model="search" outlined :label="$t('search')"></v-text-field>
    </v-row>
    <v-data-table :search="search" :headers="headers" dense :items="medicalInstitutions" :height="pageHeight(50)"  hide-default-footer :items-per-page="-1">
      <template v-slot:item="{item, index}">
        <tr :class="getOddRows(index)" v-if="item.id !== 0" @click="getOrganizationItems(item)">
          <td class="text-left font-size12-5 font-weight-medium">
            {{item.institutionName}}
          </td>
          <td  class="text-right font-size12-5 font-weight-medium">
            <v-radio-group hide-details class="ml-2 mt-n2 float-end " v-model="selectedOrganization">
              <v-radio
               :value="item.id"
              ></v-radio>
            </v-radio-group>
          </td>
        </tr>
      </template>
    </v-data-table>
    <v-card-actions class="fixed-card-actions">
      <v-row class="mb-0">
        <v-col cols="6">
          <v-btn
              @click="closeDrawer"
              elevation="0"
              class="cancel-button-style capitalize-text"
          >
            {{ $t("cancel") }}
          </v-btn>
        </v-col>
        <v-col cols="6">
          <v-btn
              @click="save"
              class="save-button-style"
              :disabled="!price || !selectedOrganization || (selectedLicence === 1 && !numberLicenses)"
          >
            {{ $t("save") }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>
<script>
import { mapGetters, mapState } from 'vuex';
import { showSuccessAlert } from '@/utils/utilities';

export default {
  name: 'AddLicense.vue',
  data () {
    return {
      price: null,
      selectedOrganization: null,
      search: '',
      selectedLicence: 0,
      numberLicenses: null,
    };
  },
  methods: {
    getOddRows (index) {
      if (index % 2 === 1) {
        return 'odd-row';
      }
      if (index % 2 === 0) {
        return 'even-row';
      }
    },
    getOrganizationItems (item) {
      this.selectedOrganization = item.id;
    },
    async save () {
      if (this.selectedLicence === 0) {
        const body = {
          price: parseInt(this.price, 10),
          organizationId: this.selectedOrganization,
        };
        const response = await this.$store.dispatch('licenses/addLicense', body);
        if (response.resFlag && response.statusCode === 201) {
          this.licenses.push(response.data); // fallback if not found
          showSuccessAlert(response.msg);
        }
      }
      if (this.selectedLicence === 1) {
        const body = {
          price: parseInt(this.price, 10),
          organizationId: this.selectedOrganization,
          nrOfLicenses: parseInt(this.numberLicenses, 10),
        };

        const response = await this.$store.dispatch('licenses/addBulkLicenses', body);
        this.licenses.push(...response.data);
      }

      this.closeDrawer();
    },
    closeDrawer () {
      this.$store.commit('SET_DETAILS_DRAWER', false);
          this.price = null;
          this.selectedOrganization = null;
          this.search = null;
          this.selectedLicence = 0;
          this.numberLicenses = null;
    },
  },
  computed: {
    ...mapGetters({
      medicalInstitutions: 'medicalInstitutions/getMedicalInstitutionsSorted',
      pageHeight: 'pageHeight',
    }),
    ...mapState({
      licenses: state => state.licenses.licenses,
    }),
    headers () {
      const headers = [
        {
          text: this.$t('medicalInstitution'),
          value: 'institutionName',
          class: 'table-header',
          align: 'start pl-3',
          sortable: false,
        },
        {
          text: '',
          value: '',
          class: 'table-header',
          align: 'end pl-3',
          sortable: false,
        },
      ];
      return headers;
    },
  },
};

</script>
